export enum TcddSubSystemName {
  TRACTION = 'traction',
  SIGNALIZATION = 'signalization',
  COMMUNICATION = 'communication',
  BRAKE = 'brake',
  POWER_VOLTAGE = 'powerVoltage',
  AIR_CONDITION = 'airCondition',
  DOOR = 'door',
  OTHER = 'other'
}
